<template>
    <div>
        <compWrapper title="基本信息" theme="primary">
            <compFormQuery
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
        </compWrapper>
        <!-- 计算历史 -->
        <compWrapper title="计算历史" theme="success" v-if="querytype=='query'">
            <!-- <vTable
                class="margin-15"
                :columns="columns"
                :data="datalist"
                size="small"
                ref="table"
                border
            ></vTable> -->
            <TableList class="margin-15" v-bind="getData"></TableList>
        </compWrapper>
        <!-- 成本调整 -->
        <compWrapper title="成本调整" theme="info" v-if="type=='edit'">
            <compFormEdit
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getCostadjust"
                v-model="newformData"
                :labelWidth="120"
            />
        </compWrapper>
        <!-- 操作历史 -->
        <compWrapper title="修改历史" theme="gray" v-if="type=='query'">
            <compLog :data="logList" :columns="logcolumns"></compLog>
        </compWrapper>
        <div class="text-right" v-if="type != 'query'">
            <vButton theme="primary" @click="submit">保存</vButton>
            <vButton class="margin-left-10" @click="close">返回</vButton>
        </div>
        <!-- 点击仓库/成本组出现的box -->
        <div v-if="type=='query'">
            <vModal
                v-model="operate.show"
                :title="operate.title"
                v-bind="operate"
            >
                <div style="min-height:50px" v-show="wareshow" v-for="(item,index) in alllist1" :key="index">{{item.label}}</div>
                <div style="min-height:50px" v-show="costshow" v-for="(item,index) in alllist2" :key="index">{{item.costType | filtercostType}}:{{item.cost}}</div>
                <div style="min-height:50px" v-show="submitshow">成本修改将影响利润计算等，请谨慎操作！确认？</div>
                <div class="text-right" v-show="submitshow">
                    <vButton theme="primary" @click="submitupdate()">确定</vButton>
                    <vButton class="margin-left-10" @click="cancel">取消</vButton>
                </div>
                <footer slot="footer" v-show="false"></footer>
            </vModal>
        </div>
        
        <vModal
                v-model="nextoperate.show"
                :title="nextoperate.title"
                v-bind="nextoperate"
            >
            <div style="min-height:50px" v-show="submitshow">成本修改将影响利润计算等，请谨慎操作！确认？</div>
            <div class="text-right" v-show="submitshow">
                <vButton theme="primary" @click="submitupdate()">确定</vButton>
                <vButton class="margin-left-10" @click="cancel">取消</vButton>
            </div>
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <!-- 添加全局的liading -->
        <vLoading size="large" transfer fix :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetCostOne,HttpGetCostComputed,HttpSaveCostOne,HttpGetCostopLog } from "@/service/boss/cost";
import { mapState,mapGetters } from "vuex";
import TableList from "@components/templates/tablelist";
export default {
    props:['jsonItem','querytype'],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        TableList
	},
    data(){
        return {
            type: this.$route.params.type,
			jsonItem: this.$route.query.jsonItem,
            formData:{},
            newformData:{},
            datalist:[],
            logList:[],
            alllist1:[],
            alllist2:[],
            operate: {
				id: null,
				title: "",
				show: false,
				component: null
            },
            nextoperate:{
                id: null,
				title: "",
				show: false,
				component: null
            },
            wareshow:false,
            costshow:false,
            submitshow:false,
            loading:false,
        }
    },
    created(){
        this.update()
    },
    computed:{
        ...mapGetters('dictionary', ['getWarehouseList']),
        ...mapGetters('diction',['getNewProductList','getAllCostGroupName','getAllCurrency']),
        getData () {
            return {
                initFormData: {
                    groupId:this.jsonItem.groupId,
                    productId:this.jsonItem.productId
                },
                ajaxRequest: HttpGetCostComputed,
                startUp: true,
                columns: this.columns
            };
        },
        getBase(){
            return [
                {
					label: "ERPSKU",
					key: "erpSku",
					required: false,
				},
                {
					label: "成本币种",
					key: "currency",
                },
                {
					label: "项目",
					key: "lineId",
					tag: "vSelect",
					options: this.getNewProductList,
					props: {
						filterable: true,
					},
                },
                {
					label: "成本组",
					key: "groupId",
                    tag: "vSelect",
                    options: this.getAllCostGroupName,
					required: false,
                },
                {
					label: "当前总成本",
					key: "cost",
					tag: "vInput",
					required: false,
                },
                {
					label: "当前采购成本",
					key: "fob",
					tag: "vInput",
					required: false,
                },
                {
					label: "当前物流成本",
					key: "lcm",
					tag: "vInput",
					required: false,
                },
                {
					label: "当前税费成本",
					key: "tax",
					tag: "vInput",
					required: false,
				},
            ]
        },
        getCostadjust(){
            return [
                {
					label: "新采购成本",
					key: "fob",
					tag: "vInput",
                },
                {
					label: "新物流成本",
					key: "lcm",
					tag: "vInput",
                },
                {
					label: "新税费成本",
					key: "tax",
					tag: "vInput",
                },
                {
					label: "调整原因",
					key: "reason",
					tag: "vInput",
                },
                {
					label: "新总成本",
					key: "newcost",
					tag: "vInput",
                    query:true,
                },
            ]
        },
        columns(){
            let _this = this;
            return [
                {
                    title: "成本组",
                    render(h,{row, index}) {
                        const groupid = row.groupId;
                        const groupitem = _this.getAllCostGroupName.filter((item) => {
                            return groupid == item.value
                        })[0] || {};
                        // console.log(groupitem)
                        return h('div',[
                            h('a', {
                                on: {
                                    click: () => {
                                        _this.changeEdit(row.orgWarehouseIdList)
                                    }
                                }
                            },groupitem.label)
                        ])
                    }
                },
                {
                    title: "期间",
                    key:'period',
                },
                {
                    title: "总成本",
                    key:'cost',
                    render(h,{row,index}){
                        return h('div',[
                            h('a', {
                                on: {
                                    click: () => {
                                        _this.changeCost(row.itemCostDetailList)
                                    }
                                }
                            },row.cost)
                        ])
                    }
                },
            ]
        },
        logcolumns(){
            return [{
				title: '操作人',
				key: 'createdName',
			}, {
				title: '修改原因',
				render(h, { row }) {
					return row.opRemark || row.remark;
				},
			}, {
				title: '操作时间',
				key: 'createdAt',
			}];
        }
    },
    methods:{
        update(){
            if(this.querytype){
                this.jsonItem = this.jsonItem
                this.type = this.querytype
            }else{
                this.jsonItem = this.$route.query.jsonItem
                this.type = this.type
            }
            // console.log(this.jsonItem)
            this.formData = this.jsonItem

            this.newformData.fob = this.formData.fob
            this.newformData.lcm = this.formData.lcm
            this.newformData.tax = this.formData.tax
            this.newformData.newcost = this.formData.cost
            
            let arrlist = this.jsonItem.itemCostDetailList; 
            
            const cost0 = arrlist.filter((item) => {
                return item.costType == 0
            })[0] || {};
            const cost1 = arrlist.filter((item) => {
                return item.costType == 1
            })[0] || {};
            const cost2 = arrlist.filter((item) => {
                return item.costType == 2
            })[0] || {};


            this.formData.fob = cost0.cost || 0
            this.formData.lcm = cost1.cost || 0
            this.formData.tax = cost2.cost || 0

            this.newformData.fob = this.formData.fob
            this.newformData.lcm = this.formData.lcm
            this.newformData.tax = this.formData.tax

            if(this.type=='query'){
                HttpGetCostComputed({
                    groupId:this.jsonItem.groupId,
                    productId:this.jsonItem.productId
                }).then(res=>{
                    // console.log(res)
                    this.datalist = res.data.content
                    // console.log(this.datalist)
                },err=>{

                })
                HttpGetCostopLog({
                    groupId:this.jsonItem.groupId,
                    productId:this.jsonItem.productId
                }).then(res=>{
                    this.logList = res.data
                },err=>{

                })
            }
        },
        changeEdit(warehouselist){
            let array = []
            // console.log(warehouselist)
            warehouselist.map(item=>{
                this.getWarehouseList.map(json=>{
                    // console.log(json)
                    if(item == json.value){
                        array.push(json)
                    }
                })
            })
            this.wareshow = true
            this.costshow = false
            this.submitshow = false
            if(array.length>0){
                this.alllist1 = array
                this.$set(this.$data,'alllist1',array || [])
                this.operate.title = '成本组'
                this.operate.show = true
            }
        },
        changeCost(costlist){
            this.costshow = true
            this.wareshow = false
            this.submitshow = false
            this.operate.title = '总成本'
            this.alllist2 = costlist
            this.operate.show = true
        },
        async submit(){
            let bool = await this.$refs.editform.validate()
            if (!bool) return
            
            this.nextoperate.title = '是否保存'
            this.nextoperate.show = true
            this.submitshow = true
            
        },
        submitupdate(){
            this.loading = true
            HttpSaveCostOne({
                fob:Number(this.newformData.fob).toFixed(4),
                lcm:Number(this.newformData.lcm).toFixed(4),
                tax:Number(this.newformData.tax).toFixed(4),
                reason:this.newformData.reason,
                groupId:this.jsonItem.groupId,
                productId:this.jsonItem.productId
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.close()
                this.loading = false
            },err=>{
                this.loading = false
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        close(){
            this.$router.push({
                name: 'costManageList',
            })
        },
        cancel(){
            this.nextoperate.show = false
            this.operate.show = false
        }
    },
    filters:{
        filtercostType:function(val){
            switch(val){
                case 0: return '采购成本'; break;
                case 1: return '运费成本'; break;
                case 2: return '税费成本'; break;
            }
        }
    },
    watch:{
        newformData:{
            deep: true,
            handler(val) {
				this.newformData.newcost = (Number(this.newformData.fob) + Number(this.newformData.lcm) + Number(this.newformData.tax)).toFixed(4)
			}
        }
    }
}
</script>

